import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function ColectieProblem() {
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-535">
      <div className="max-w-4xl mx-auto px-6" data-id="element-536">
        <SectionHeading title="Simți că viața ta poate fi mai bună, dar nu știi de unde să începi?" data-id="element-537" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-brand-cream rounded-3xl p-8 md:p-12 shadow-sm border border-brand-text/5 mb-12" data-id="element-538">
          <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed" data-id="element-539">
            <p className="font-bold text-xl text-brand-text" data-id="element-540">
              Muncești mult, dar nu te simți împlinit/ă.
            </p>
            <p data-id="element-541">
              Ai o relație complicată cu banii, parcă oricât ai câștiga nu e de
              ajuns. Te simți blocat/ă emoțional, anxios/anxioasă sau stresat/ă
              și nu înțelegi de ce te lovești mereu de aceleași tipare. Ai citit
              cărți, ai meditat, ai fost la cursuri, dar nimic nu s-a schimbat
              cu adevărat.
            </p>
            <p data-id="element-542">
              Și știi care e partea cea mai grea? Cu fiecare zi care trece fără
              o schimbare reală, stresul crește, relațiile se tensionează, iar
              sentimentul că îți irosești viața devine tot mai puternic.
              Informația fără practică și fără ghidare nu te duce nicăieri.
            </p>

            <div className="mt-8 p-6 bg-brand-gold/5 border-l-4 border-brand-gold rounded-r-xl" data-id="element-543">
              <p className="font-medium text-brand-text italic" data-id="element-544">
                Academia de Abundență este un program complet de 6 cursuri
                online prin care te ghidez pas cu pas să identifici credințele
                din subconștient care te blochează, să le transformi și să
                creezi mai multă abundență în toate ariile vieții tale. Nu doar
                teorie, ci meditații ghidate, exerciții practice și susținere
                reală într-o comunitate de oameni care cresc împreună.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-545">
          <CTAButton data-id="element-546" />
        </motion.div>
      </div>
    </section>;
}